import styled from "styled-components";

const Loader = ({ title }) => {
  return (
    <LoaderContainer>
      <l-line-spinner size="32" stroke="2.5" speed="1" color="#ff6b35" />

      <p>Učitavanje {title}...</p>
    </LoaderContainer>
  );
};

export default Loader;

export const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  gap: 1rem;
  color: #ccc;
`;
